/**
 * Created by PanJiaChen on 16/11/18.
 */
// 这个是框架自带的文件，可能只调用了第三个检验手机的方法
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername (str) {
  // eslint-disable-next-line camelcase
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

export var checkPhone = (rules, value, cb) => {
  // 验证手机号的正则表达式
  const regPhone = /^1[0-9]{10}$/
  // const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
  if (regPhone.test(value)) {
    return cb()
  }
  cb(new Error('请输入合法的手机号'))
}
